function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 21a9 9 0 100-18 9 9 0 000 18zm0-1.2a7.8 7.8 0 100-15.6 7.8 7.8 0 000 15.6z",
  fill: "#6F8190"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-1.2 0a7.8 7.8 0 11-15.6 0 7.8 7.8 0 0115.6 0z",
  fill: "#29354C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 6.6a.6.6 0 01.6.6v4.551l3.124 3.125a.6.6 0 11-.848.848L11.4 12.248V7.2a.6.6 0 01.6-.6z",
  fill: "#29354C"
});

var SvgIconTime = function SvgIconTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAyMUMxNi45NzA2IDIxIDIxIDE2Ljk3MDYgMjEgMTJDMjEgNy4wMjk0NCAxNi45NzA2IDMgMTIgM0M3LjAyOTQ0IDMgMyA3LjAyOTQ0IDMgMTJDMyAxNi45NzA2IDcuMDI5NDQgMjEgMTIgMjFaTTEyIDE5LjhDMTYuMzA3OCAxOS44IDE5LjggMTYuMzA3OCAxOS44IDEyQzE5LjggNy42OTIxOCAxNi4zMDc4IDQuMiAxMiA0LjJDNy42OTIxOCA0LjIgNC4yIDcuNjkyMTggNC4yIDEyQzQuMiAxNi4zMDc4IDcuNjkyMTggMTkuOCAxMiAxOS44WiIgZmlsbD0iIzZGODE5MCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIxIDEyQzIxIDE2Ljk3MDYgMTYuOTcwNiAyMSAxMiAyMUM3LjAyOTQ0IDIxIDMgMTYuOTcwNiAzIDEyQzMgNy4wMjk0NCA3LjAyOTQ0IDMgMTIgM0MxNi45NzA2IDMgMjEgNy4wMjk0NCAyMSAxMlpNMTkuOCAxMkMxOS44IDE2LjMwNzggMTYuMzA3OCAxOS44IDEyIDE5LjhDNy42OTIxOCAxOS44IDQuMiAxNi4zMDc4IDQuMiAxMkM0LjIgNy42OTIxOCA3LjY5MjE4IDQuMiAxMiA0LjJDMTYuMzA3OCA0LjIgMTkuOCA3LjY5MjE4IDE5LjggMTJaIiBmaWxsPSIjMjkzNTRDIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTEuOTk5OSA2LjU5OTk4QzEyLjMzMTMgNi41OTk5OCAxMi41OTk5IDYuODY4NiAxMi41OTk5IDcuMTk5OThWMTEuNzUxNEwxNS43MjQyIDE0Ljg3NTdDMTUuOTU4NSAxNS4xMSAxNS45NTg1IDE1LjQ4OTkgMTUuNzI0MiAxNS43MjQyQzE1LjQ4OTkgMTUuOTU4NiAxNS4xMSAxNS45NTg2IDE0Ljg3NTYgMTUuNzI0MkwxMS4zOTk5IDEyLjI0ODVWNy4xOTk5OEMxMS4zOTk5IDYuODY4NiAxMS42Njg1IDYuNTk5OTggMTEuOTk5OSA2LjU5OTk4WiIgZmlsbD0iIzI5MzU0QyIvPgo8L3N2Zz4K";
export { SvgIconTime as ReactComponent };